// Reducer for paymentMethod

import {
  GET_PAYMENT_METHOD_LIST,
  GET_PAYMENT_METHOD_LIST_SUCCESS,
  GET_PAYMENT_METHOD_LIST_FAILURE,
} from "./actionType";
const initialState = {
  paymentMethodList: [],
};

export default function PaymentMethod(state = initialState, action) {
  switch (action.type) {
    case GET_PAYMENT_METHOD_LIST:
      return {
        ...state,
      };
    case GET_PAYMENT_METHOD_LIST_SUCCESS:
      return {
        ...state,
        paymentMethodList: action.payload,
      };
    case GET_PAYMENT_METHOD_LIST_FAILURE:
      return {
        ...state,
      };
    default:
      return state;
  }
}
